module.exports = __webpack_public_path__ + "../PRODUS/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../PRODUS/[name].[ext]!./configs/appSettings/PRODUS/appsettings.js
// module id = 760
// module chunks = 1